export default __webpack_public_path__ + "static/media/new-why_choose.7b01a5a3.jpg";